//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { useSearchParams } from 'react-router-dom';

// ### MUI / STYLES ###
import { useTheme } from '@mui/material/styles';
import { Box, CircularProgress, Paper, Typography } from '@mui/material';

// === COMPONENTS ===
import { DataPanel  } from './components/DataPanel/DataPanel';
import { ImagePanel } from './components/ImagePanel';

// === API ===
import { clearFocus, on, removeListener, requestAuditTask, requestDocumentRuleTasks } from 'api/prokey/prokey.websocket';
import {ThumbPanel} from './components/ThumbPanel/index';

//#endregion

//-----------------------------------------------------------------
export function TaskView( ) {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const { file_id, exception_id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams()

  const theme = useTheme();

  const [ task, setTask ] = useState( null );

  const _styles = {
    container: {
      display: 'grid',
      padding: '1rem',
      width: `100%`,
      height: `calc( 100% - 1rem )`,
      zIndex: '0',
      gridTemplateColumns: 'repeat(12, 1fr)',
      gridGap: '1rem',
    },
    spinner_box: {
      position: 'fixed',
      top: '50%',
      left: '50%',
      height: '14rem',
      width: '10rem',
      textAlign: 'center'
    },
    spinner: {
      margin: '2rem',
    },
    spinner_caption: {},
  };

  //#endregion

  //#region [PROCES]

  useEffect(() => {
    //-----------------------------------------------------------------    
    function handleTask(data) {
      //-----------------------------------------------------------------
      setTask(data);
    }

    on( 'AUDIT-TASK' , handleTask );

    const document = searchParams.get( 'document' );
    requestDocumentRuleTasks( file_id , document );

    return () => {
      removeListener( 'AUDIT-TASK', handleTask );
      clearFocus();
    };
  }, []); // empty dependency = called only once at startup

  //#endregion

  //#region [RENDER]

  //-----------------------------------------------------------------
  function dislpay() {
    //-----------------------------------------------------------------
    if(!task) return (
      <Box sx={_styles.container}>
        <Paper sx={_styles.spinner_box}>
          <CircularProgress sx={_styles.spinner} size='6rem' />
          <Typography variant='button' sx={_styles.spinner_caption} display='block'>
            Loading Document
          </Typography>
        </Paper>
      </Box>
    );

    return (
      <Box sx={_styles.container}>
        <DataPanel data={task}/>
        <ImagePanel />
        <ThumbPanel documents={task.documents} images={task.images}/>
      </Box>
    );
  }
  //#endregion

  return dislpay();
}